import { createFileRoute } from "@tanstack/react-router"
import { Admin } from "@/admin"

export const Route = createFileRoute("/admin")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Admin />
}
